import { ColumnsType } from 'antd/es/table';
import { tableSortingMethods } from '../../../../utils';
import { BusinessFunction } from './types';

export const businessFunctionColumns: ColumnsType<BusinessFunction> = [
  {
    key: 'name',
    dataIndex: 'name',
    title: 'Business Function',
    align: 'left',
    width: 200,
    sorter: (a, b) => tableSortingMethods.string(a.name, b.name),
    render: (text) => <span className="custom-table--column">{text}</span>,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    align: 'left',
    sorter: (a, b) => tableSortingMethods.string(a.description, b.description),
    render: (text) =>
      text ? (
        <span className="custom-table--column">{text}</span>
      ) : (
        <span className="placeholder-text text-sm">Not Provided</span>
      ),
  },
];
